"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tick = function Tick(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M0 0V24H24V0H0ZM19.3536 7.35356L15.3536 11.3536L9.35356 17.3536C9.30717 17.4 9.25206 17.4369 9.19139 17.4621C9.13071 17.4872 9.06567 17.5001 9 17.5H8.99961C8.93399 17.5001 8.86899 17.4872 8.80837 17.4621C8.74774 17.437 8.69267 17.4001 8.64633 17.3536L6.64633 15.3536C6.64369 15.3509 6.64147 15.3481 6.63889 15.3453L5.64722 14.3536C5.55645 14.2594 5.50629 14.1332 5.50753 14.0024C5.50877 13.8715 5.56131 13.7464 5.65385 13.6538C5.74639 13.5613 5.87155 13.5088 6.00241 13.5075C6.13327 13.5063 6.2594 13.5564 6.35367 13.6472L8.35367 15.6472C8.35644 15.65 8.35858 15.6528 8.36117 15.6556L8.99933 16.2937L12.6464 12.6466L18.6464 6.64656C18.7403 6.5536 18.8672 6.50161 18.9994 6.50195C19.1315 6.5023 19.2582 6.55495 19.3516 6.6484C19.4451 6.74185 19.4977 6.8685 19.4981 7.00066C19.4984 7.13282 19.4464 7.25973 19.3534 7.35367L19.3536 7.35356Z",
    fill: props.foregroundColor
  }));
};

Tick.defaultProps = {
  altText: "Tick",
  backgroundColor: "#FFFFFF",
  foregroundColor: "#2D5AB4"
};
Tick.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Tick;
exports.default = _default;